<template>
  <div class="content">
    <el-row>
      <el-row class="search">
        <el-col :span="6">
          <div class="grid-content">
          </div>
        </el-col>
        <el-col :span="10">
          <el-form ref="form" :model="searchForm" label-width="80px" size="mini" label-position="left">
            <el-row>
              <el-col :span="7">
                <el-form-item label="标题" size="mini">
                  <el-input v-model="searchForm.title" size="mini"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="7">
                <el-form-item label="类别" style="padding-left:15px">
                  <el-select v-model="searchForm.type" style="width:100%" size="mini">
                    <el-option v-for="item in type" :value="item.id" :label="item.name" :key="item.id">{{item.name}}
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="发帖时间" style="padding-left:15px" size="mini">
                  <el-date-picker style="width:100%" v-model="searchDate" type="daterange" start-placeholder="开始日期"
                                  end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="7">
                <el-form-item label="回复状态" size="mini">
                  <el-select v-model="searchForm.status" style="width:100%">
                    <el-option value="-1" label="全部" key="-1">全部</el-option>
                    <el-option value="1" label="已回复" key="1">已回复</el-option>
                    <el-option value="0" label="未回复" key="0">未回复</el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="10">
                <el-form-item label="服务类型" style="padding-left:15px" size="mini">
                  <el-cascader ref="serviceItemTree" :props="servicesProps" size="mini"
                               style="width:100%"></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>

        <el-col :span="4" style="padding-left:15px">
          <!-- <el-tree ref="serviceItemTree" v-model="searchForm.serviceItem" :props="props1" :load="loadServiceItem" lazy show-checkbox node-key="id"></el-tree> -->
          <el-button type="" @click="search" icon="el-icon-search" size="mini">查询</el-button>
        </el-col>

      </el-row>

    </el-row>

    <el-row>
      <el-col :span="4">
        <div class="grid-content"></div>
      </el-col>

      <el-col :span="16" class="">
        <el-table :data="tableData" style="min-height:570px;" @row-click="openDetails" :row-style="{height:'35px'}"
                  class="tableClass" size="medium">


          <el-table-column label="分类">
            <template slot-scope="scope">

              <el-tag v-if="scope.row.tieziType=='1'" type="danger">投诉 — {{scope.row.serviceItemIdName}}</el-tag>
              <el-tag v-if="scope.row.tieziType=='2'" type="warning">建议 — {{scope.row.serviceItemIdName}}</el-tag>
              <el-tag v-if="scope.row.tieziType=='3'" type="warning">咨询 — {{scope.row.serviceItemIdName}}</el-tag>
              <el-tag v-if="scope.row.tieziType=='4'" type="warning">表扬 — {{scope.row.serviceItemIdName}}</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="title" label="标题">
          </el-table-column>
          <el-table-column prop="userName" label="发帖人">
          </el-table-column>

          <el-table-column label="状态">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.commentCount>0" type="success">已回复</el-tag>
              <el-tag v-if="scope.row.commentCount==0" type="info">未回复</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="createDate" label="发布时间">
          </el-table-column>

        </el-table>
      </el-col>


    </el-row>

    <el-row style="text-align:center; padding-top:10px">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="searchForm.size"
                     @current-change="handleCurrentChange" :current-page.sync="searchForm.page"></el-pagination>
    </el-row>

    <!-- <el-footer></el-footer> -->
  </div>
</template>

<script>
  import {getServiceItemByPid, getPostList, OK, HOST} from '../../api/data.js'

  let id = 0;
  export default {
    data() {
      let _this = this
      return {
        tableData: [],
        searchForm: {
          title: '',
          type: 0,
          status: '-1',
          date: '',
          author: '',
          serviceItem: '',
          page: 1,
          size: 10
        },
        type: [],
        show: false,
        more: 'el-icon-caret-bottom',
        props1: {
          label: 'name',
          children: 'zones',
          isLeaf: 'leaf'
        },
        serviceItem: '',
        searchDate: [],
        total: 1,
        servicesProps: {
          multiple: true,
          label: 'name',
          value: 'id',
          leaf: 'leaf',
          lazy: true,
          lazyLoad(node, resolve) {
            const {
              level
            } = node;
            if (node.level === 0) {
              getServiceItemByPid(id).then((res) => {
                resolve(res.data.data)
              }).catch(function (res) {
                console.log(res);
              })

            }

            if (node.level > 0) {
              getServiceItemByPid(node.data.id).then((res) => {
                resolve(res.data.data)
              }).catch(function (res) {
                console.log(res);
              })


            }
          }
        }
      }

    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert("success");
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      openDetails(row) {
        // alert(row.id);
        this.$router.push({
          path: '/casDetail',
          query: {
            detailId: row.id
          }
        })
      },
      search() {
        this.getCheckedNodes()
        this.dateFormat()
        this.searchForm.page = 1
        // var formdata = JSON.parse(JSON.stringify(this.searchForm))
        // console.log(formdata)
        this.getCasList()
      },
      searchMore() {
        this.show = !this.show;
        if (this.show) {
          this.more = 'el-icon-caret-top';
        } else {
          this.more = 'el-icon-caret-bottom';
        }
      },
      dateChange(val) {
        this.searchForm.date = val;
      },
      loadServiceItem(node, resolve) {
        let _this = this
        if (node.level === 0) {
          getServiceItemByPid(id).then((res) => {
            resolve(res.data.data)
          }).catch(function (res) {
            console.log(res);
          })

        } else {
          getServiceItemByPid(node.data.id).then((res) => {
            resolve(res.data.data)
          }).catch(function (res) {
            console.log(res);
          })

        }
      },
      getCasList() {
        let _this = this
        getPostList(this.searchForm.title, this.searchForm.type, this.searchForm.status, this.searchForm.date, this.searchForm.author, this.searchForm.serviceItem, this.searchForm.page, this.searchForm.size).then((res) => {
          _this.tableData = res.data.data.list
          _this.total = res.data.data.total
        }).catch(function (res) {
          console.log(res);
        })
      },
      getServiceItem(id) {
        let _this = this
        getServiceItemByPid(id).then((res) => {

        }).catch(function (res) {
          console.log(res);
        })
      },
      getCheckedNodes() {
        this.searchForm.serviceItem = ''
        let items = this.$refs.serviceItemTree.getCheckedNodes()

        for (let item in items) {
          if (this.searchForm.serviceItem != '')
            this.searchForm.serviceItem += ","
          this.searchForm.serviceItem = this.searchForm.serviceItem + items[item].data.id
        }
      },
      dateFormat() {
        this.searchForm.date = this.searchDate + ''

      },
      handleCurrentChange() {
        this.getCasList()
      }
    },
    mounted() {
      setTimeout(() => {
        let type_json = this.common.getType();
        this.type = JSON.parse(type_json);
        this.getCasList()
      }, 20)

    },
    created() {
    }

  }
</script>


<style>
  .form_border {
    border: 1px solid grey;
    padding: 5px;
    border-radius: 10px;
  }

  .content {
    /* background: #FBFBFB */
  }

  .search {
    /* border: 1px solid grey; */
    padding: 5px;
    border-radius: 5px;
    /* background: rgba(240, 242, 244, 1); */
    /* background-color: white */
  }

  .list {
    border-top: 2px solid #00458E;
    /* border: 2px solid #FFF6F7; */
    /* box-shadow: 0 0px 3px 0px #00458E; */
    border-radius: 1px;
    padding: 15px;
  }

  .el-tree {
    background: none;
    overflow: auto;
  }

  .el-tree-node__content:hover {
    background: none;
  }

  .testborder {
    border: 1px solid black
  }

  .tableClass {
    border-radius: 3px;
    box-shadow: 0 2px 10px 0 rgba(255, 255, 255, 0.5);
    padding-left: 5%;
    padding-right: 5%
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/ComplaintsAndSuggestionsList.vue